import { Component } from '@nicolas-riciotti/light2';
import Lenis from '../../helpers/Lenis'
import getPosition from '../../helpers/getPosition'

import BezierEasing from '../../helpers/BezierEasing.js'
const easing = BezierEasing(.43,.195,.02,1);

export default class BlockHeroCircles extends Component {

    created() {
        this.onScroll = this.onScroll.bind(this);
        this._scroll = 0;
        this._top = 0;
        this._height = 0;
    }

    onScroll(e) {
        this._scroll = e.animatedScroll;
    }

    attached() {
        this.$canvas = this.querySelector('canvas');
        this.ctx = this.$canvas.getContext('2d');

        this.strokeColor = this.getAttribute('data-stroke-color') ?? '#fff';

        this.progress = 0;
        this._time = 0;
        this._intersecting = false;

        this._io = new IntersectionObserver((entries) => {
            for (const e of entries) {
                this._intersecting = e.isIntersecting;
            }
        }, { threshold: 0.15 });

        this._io.observe(this);
        Lenis?.on?.('scroll', this.onScroll);
        this.resize();
    }

    resize() {

        this._height = this.clientHeight;
        this.dpr = Math.min(window.devicePixelRatio || 1, 2);

        const width = this.$canvas.clientWidth;
        const height = this.$canvas.clientHeight;

        this.$canvas.width = Math.round(width * this.dpr);
        this.$canvas.height = Math.round(height * this.dpr);

        this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);

        this.canvasWidth = width;
        this.canvasHeight = height;
    }

    detached() {
        this._io?.disconnect();
    }

    update(now) {
        // if (!this._intersecting) return;

        const width = this.canvasWidth || this.$canvas.clientWidth;
        const height = this.canvasHeight || this.$canvas.clientHeight;

        this._time = now * 0.0001;

        // 0 -> 1 -> 0 loop
        this.progress = Math.min(1, Math.max(0, this._scroll / (this._height)));

        const ctx = this.ctx;

        ctx.clearRect(0, 0, width, height);

        ctx.save();

        ctx.strokeStyle = this.strokeColor
        ctx.lineWidth = 1;

        const count = 8;

        const bottomY = height;
        const centerX = width * 0.5;

        const minDiameter = height * 1.12;
        const maxDiameter = height * 2.75;

        const circleDelay = 0.08;
        const fadeEnd = 0.25;
        const strokeAlpha = 1;

        // Fade the whole set out as the hero unpins and real scrolling begins.
        // The section is sticky for ~200vh of a 300vh block, so it unlocks at
        // progress ~0.67. Start the fade just before that and finish quickly so
        // the circles are gone the moment the content starts moving.
        const fadeOutStart = 0.6;
        const fadeOutEnd = 0.74;
        const fadeOut = this.mapClamp(this.progress, fadeOutStart, fadeOutEnd, 1, 0);

        for (let i = 0; i < count; i++) {
            const t = i / (count - 1);

            const finalDiameter = this.lerp(maxDiameter, minDiameter, t);

            const start = i * circleDelay;

            const localProgress = this.clamp01(
                (this.progress - start) / (1 - start)
            );

            const easedProgress = easing(localProgress);

            const alpha = this.mapClamp(localProgress, 0, fadeEnd, 0, 1) * strokeAlpha * fadeOut;

            const diameter = finalDiameter * easedProgress;
            const radius = diameter * 0.5;

            const x = centerX;
            const y = bottomY - radius;

            ctx.globalAlpha = alpha;

            ctx.beginPath();
            ctx.arc(x, y, radius, 0, Math.PI * 2);
            ctx.stroke();
        }

        ctx.restore();
    }

    lerp(a, b, t) {
        return a + (b - a) * t;
    }

    clamp01(v) {
        return Math.max(0, Math.min(1, v));
    }

    mapClamp(value, inMin, inMax, outMin, outMax) {
        const t = this.clamp01((value - inMin) / (inMax - inMin));
        return this.lerp(outMin, outMax, t);
    }

}

customElements.define('block-hero-circles', BlockHeroCircles);